const doc = [({"en":({"models":({"number_of_students_csv":({"isnt_a_csv_file":"with the extension %{ext} and content type %{content_type} isnt a CSV"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;